export default "__VITE_ASSET__59756e9c__"